module.exports = __webpack_public_path__ + "static/media/gh-1.972f46ac.png";